import { routes } from 'vue-router/auto-routes'
import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  routes,
  history: createWebHistory(import.meta.env.BASE_URL),
})
window.router = router
